import { H6, Image, P } from "@template/components";
import * as S from "./styles.ts";
import { StaticImageData } from "next/image";

export interface ICostCardProps {
  destination: string;
  destinationFlagUrl: string | StaticImageData;
  price?: string;
  priceCopy?: string;
}

export const CostCard = ({
                           destination,
                           destinationFlagUrl,
                           price,
                           priceCopy,
                         }: ICostCardProps) => {
  return (
    <S.CostCardContainer>
      <S.Row>
        <P>Destination</P>
        <S.PriceLabel>
          <P>{priceCopy}</P>
          <P>/min</P>
        </S.PriceLabel>
      </S.Row>

      <S.Row>
        <S.Destination>
          <S.Flag>
            <Image
              src={destinationFlagUrl}
              alt={`Flag of ${destination}`}
              width={32}
              height={32}
            />
          </S.Flag>
          <H6>{destination}</H6>
        </S.Destination>

        <S.Price>
          <P>{price}P</P>
        </S.Price>
      </S.Row>
    </S.CostCardContainer>
  );
};
